import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

import { FuseSidebarService } from '../../../@fuse/components/sidebar/sidebar.service';

export const QUICK_ORDER_PANEL_NAME = 'quickOrderPanel';

export interface QuickOrderPanelData {
  event_date?: string | null;
}

@Injectable({ providedIn: 'root' })
export class QuickOrderPanelService {
  private _result$: Subject<any | false> | null = null;
  private readonly _isOpen$ = new BehaviorSubject<boolean>(false);
  private _data: QuickOrderPanelData | null = null;

  readonly isOpen$ = this._isOpen$.asObservable();

  constructor(private _fuseSidebarService: FuseSidebarService) {}

  open(data?: QuickOrderPanelData): Observable<any | false> {
    if (this._result$) {
      this._result$.complete();
    }
    this._result$ = new Subject<any | false>();
    this._data = data ?? null;

    this._isOpen$.next(true);
    setTimeout(() => {
      const sidebar = this._fuseSidebarService.getSidebar(
        QUICK_ORDER_PANEL_NAME,
      );
      sidebar?.open();
    });

    return this._result$.asObservable().pipe(take(1));
  }

  getData(): QuickOrderPanelData | null {
    return this._data;
  }

  emitResult(result: any | false): void {
    const sidebar = this._fuseSidebarService.getSidebar(
      QUICK_ORDER_PANEL_NAME,
    );
    sidebar?.close();

    this._result$?.next(result);
    this._result$?.complete();
    this._result$ = null;
    this._data = null;
    this._isOpen$.next(false);
  }
}
